<template>
  <div class="c-sider">
    <div class="c-add-comp">
      <Moduler title="添加组件">
        <Clock v-model="current" :data="data" @on-add="addSider"></Clock>
      </Moduler>
    </div>
  </div>
</template>
<script>
import Moduler from '../base/moduler'
import Clock from './clock'
export default {
  name: 'sider',
  components: { Moduler, Clock },
  props: {
    value: {
      type: Number
    },
    data: {
      type: Array
    }
  },
  computed: {
    current: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    addSider(id) {
      const slide = this.data.filter((ret) => ret.id === id).pop()
      this.$emit('input', id)
      slide && this.$emit('on-add', slide)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-sider {
  width: 100%;
  padding: 24px 16px;

  .c-add-comp {
    height: 325px;
  }
}
</style>
